import Vue from 'vue'
import Vuetify, {
  VApp, // required
  VCard,
  VCardActions,
  VCardText,
  VForm,
  VTextField,
  VBtn,
  VSpacer,
  VContent,
  VContainer,
  VImg,
  VLayout,
  VFlex,
  VNavigationDrawer,
  transitions
} from 'vuetify/lib'
import { Ripple } from 'vuetify/lib/directives'
import pt from 'vuetify/es5/locale/pt'

Vue.use(Vuetify, {
  components: {
    VApp,
    VCard,
    VCardActions,
    VCardText,
    VForm,
    VTextField,
    VBtn,
    VSpacer,
    VContent,
    VContainer,
    VImg,
    VLayout,
    VFlex,
    VNavigationDrawer,
    transitions
  },
  directives: {
    Ripple
  },
  theme: {
    primary: '#26A69A',
    secondary: '#004D40',
    accent: '#00838F',
    error: '#E74444',
    warning: '#FBC02D',
    info: '#4099DE',
    success: '#6BBB49'
  },
  iconfont: 'fa',
  lang: {
    locales: { pt },
    current: 'pt'
  }
})
